import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { UiService } from 'src/app/services/ui.service'

@Component({
  selector: 'app-aws-marketplace',
  templateUrl: './aws-marketplace.component.html',
  styleUrls: ['./aws-marketplace.component.scss'],
  standalone: false,
})
export class AwsMarketplaceComponent implements OnInit {
  private entitlementToken: string = null

  constructor(
    private activatedRoute: ActivatedRoute,
    public uiService: UiService,
    private router: Router
  ) {}

  ngOnInit() {
    this.entitlementToken = this.activatedRoute.snapshot.queryParamMap.get('awsToken')
    if (!this.entitlementToken) {
      this.router.navigateByUrl(this.uiService.awsMarketplaceErrorUrl)
    }
  }

  newAccountClick() {
    this.router.navigateByUrl(this.uiService.buildCreateAccountUrl(), {
      state: { entitlementToken: this.entitlementToken },
    })
  }

  existingAccountClick() {
    this.router.navigateByUrl(this.uiService.buildLinkAwsMarketplaceToAccountUrl(this.entitlementToken))
  }
}
